<template>
  <header class="entry-layout-header">
    <span class="entry-layout-header-logo">
      <img :src="logo" :style="logoStyle">
    </span>
    <div class="entry-layout-menus">
      <a-tabs :activeKey="menusActiveID">
        <a-tab-pane v-for="menuInfo in menus.filter(item => paidPageFlag === 1 ? ( item.childMenus.some(subItem => subItem.updateFlag === 1) ? true : false ) : true)" :key="menuInfo.key" :closable="menuInfo.closable">
          <a-dropdown slot="tab" v-model="menuInfo.visible">
            <span
              class="entry-layout-header-menus__item__label"
              :class="{'entry-layout-header-menus__item__label--hover': menuInfo.visible}"
              :style="disabledMenu && disabledStyle"
              @click="handleMenuChange(menuInfo.key)"
            >{{ menuInfo | menuLocalName }}</span>
            <div class="entry-layout-header-menus__item__children" slot="overlay" v-show="!disabledMenu">
              <div class="entry-layout-header-menus__item__children__tools">
                <a-tooltip placement="bottom" v-if="paidPageFlag">
                  <template slot="title">
                    <span>{{ paidPageFlag === 2 ? $t('layouts.hide', [$t('layouts.paidPage')]) : $t('layouts.show', [$t('layouts.paidPage')]) }}</span>
                  </template>
                  <a-button type="link" :icon="paidPageFlag === 1 ? 'eye-invisible' : 'eye'" style="color: #999" @click.stop="switchPaidPageFlag"></a-button>
                </a-tooltip>
              </div>
              <menus-item
                v-for="(childMenus, index) in menuInfo.childMenus.filter(find => paidPageFlag === 2 ? true : find.updateFlag === 1)"
                :key="index"
                :currentLang="currentLang"
                :menu="childMenus"
                :favorites="favorites"
                @click="handleMenuChange"
              />
            </div>
          </a-dropdown>
        </a-tab-pane>
      </a-tabs>
    </div>

    <div class="entry-layout-search-wrapper">
      <a-popover v-model="visible" placement="bottomLeft" trigger="focus">
        <a-input class="entry-layout-search-input"
          ref="searchInput"
          v-model="keyword"
          size="small" allow-clear
          style="font-size:12px;"
          :placeholder="$t('layout.searchKeyword')"
          @focus="show"
          @blur="hide"
          @keydown="searchKepDown"
          @select="keywordSelectAllFlag = true"
          @click="keywordSelectAllFlag = false"
        >
          <a-icon slot="prefix" type="search" class="entry-layout-search-icon" />
        </a-input>

        <!-- 搜索结果 -->
        <div class="entry-layout-history" slot="content">
          <div class="entry-layout-history__body">
            <div
              v-for="(link, index) in searchList"
              :key="index"
              class="entry-layout-history__link"
              @click="handleSearchClick(link.key, { statisticsType: 1, searchKey: keyword, menuType: link.menuType }, link.menuName.zh_CN)"
            >
              <div class="entry-layout-history__link__main" v-html="link.html">{{ link | menuLocalName }}</div>
              <a-icon class="entry-layout-history__icon" type="caret-right" />
            </div>
            <div v-if="searchList.length === 0" class="entry-layout-history__empty">{{ $t('layouts.text.undefined') }}</div>
          </div>
          <div class="entry-layout-history__foot">
            <div class="entry-layout-history__foot__btn" @click="viewAll">
              <a-icon type="menu" style="margin-right:10px;" />
              <span>{{ $t('layouts.ViewAll') }}</span>
            </div>
          </div>
        </div>
        <!-- 猜你想搜 -->
        <div v-if="likelySearchList.length" class="entry-layout-history" slot="title">
          <div class="entry-layout-history__header">
            <div class="entry-layout-history__title">
              <span>{{ $t('layouts.maylike') }}：</span>
            </div>
            <div class="entry-layout-history__list">
              <div
                class="entry-layout-history__item"
                v-for="pane in likelySearchList"
                :key="pane.key"
                @click="handleSearchClick(pane.key, { statisticsType: 3, searchKey: '' }, pane.menuName.zh_CN)"
              >{{ pane | menuLocalName }}</div>
            </div>
          </div>
        </div>
        <!-- 历史记录 -->
        <div class="entry-layout-history" slot="title">
          <div class="entry-layout-history__header">
            <div class="entry-layout-history__title">
              <span>{{ $t('layouts.history') }}：</span>
              <span v-if="panesHistory.length === 0" style="color:#999;">{{ $t('layouts.text.undefined') }}</span>
            </div>
            <div class="entry-layout-history__list">
              <div
                v-for="pane in panesHistory"
                :key="pane.key"
                class="entry-layout-history__item"
                @click="handleSearchClick(pane.key, { statisticsType: 3, searchKey: '', menuType: 1 }, pane.menuName.zh_CN)"
              >
                {{ pane | menuLocalName }}
              </div>
            </div>
          </div>
        </div>
      </a-popover>
    </div>

    <slot name="rightContentRender" />
  </header>
</template>

<script>
import { i18nRender } from '@/locales'
import EntryLayoutMenusItem from './EntryLayoutMenusItem'
import { filterPane, findPane } from '@/store/_util/util'
import { updateSystemUpdateFlag } from '@/api/sso/role'
import { mapGetters } from 'vuex'
import { MENU_DISABLE } from '@/store/mutation-types'
import { getDetaultList } from '@/utils/util'

export default {
  name: 'EntryLayoutHeader',
  components: {
    menusItem: EntryLayoutMenusItem
  },
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    menus: {
      type: Array,
      default: () => []
    },
    subMenus: {
      type: Array,
      default: () => []
    },
    customTabs: {
      type: [Array, Array],
      default: () => [[], []]
    },
    customMenus: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    },
    panesHistory: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAdCAMAAABopjdHAAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMAgMDw4BBgIFAwsECR0aBwqphYyIhPo2vqAAABDElEQVQoz22S3XbEIAiEg6DxP7vbzvu/agXjadJ0LhLgQ8ajbheVz779pz2jM/lH3ROADkj4A4IArn5yA1y6Gji4eK49BN0vgw6Ol7kVTBYRg9N9NCCjNeMEPlCmuBCOzQG2ncgAZrO10yBO40Q4FdTaiIVUCUtl5N2IerB8n3WWrLOVuGnZ3g1Aq8JVW5Voi42KK9CtKqmrwPsYsoxs2iKoG9+ImKGK508LSQn0usRqb/vSyA8lFiWb022JnnQz0jQMA7EoSNY4SH5Jt7ug6oB53V6+XrQVOypTKWkGbs7c7WAv8s6WWm+D+31PUdBXZv45aJoOQSu3CRWnODweojOgBg8VQZ4GT6Vr8gOUzBNDdAAY6QAAAABJRU5ErkJggg==',
      logoStyle: { display: 'inline-block', height: '28px' },
      selectedKeys: [],
      dataSource: [
        { title: 'AntDesign', count: 10000 },
        { title: 'AntDesign UI', count: 10600 }
      ],
      defaultList: getDetaultList(),
      keyword: '',
      visible: false,
      // 搜索框埋点相关操作开关
      buriedShenceFlag: false, // 是否需要失去焦点时发送埋点
      backspaceFlag: false, // 是否按的删除回退键
      keywordSelectAllFlag: false, // 是否选中输入框
      disabledStyle: { opacity: '0.5', cursor: 'not-allowed' }
    }
  },
    computed: {
     // 是否禁用菜单
    disabledMenu () {
      return `${this.$ls.get(MENU_DISABLE)}` === '1'
    },
    searchList () {
      const { defaultList, keyword } = this.$data
      const { menus, subMenus, currentLang } = this.$props
      const target = keyword.toLowerCase().trim()
      const list = filterPane(menus, { lastMenu: 2 })
      const menusList = [...subMenus, ...list, ...defaultList]
        .filter((menu) => {
          const menuName = menu.menuName?.[currentLang] || menu.tab
          return ~menuName.toLowerCase().indexOf(target)
        })
        .map((menu) => {
          const menuName = menu.menuName[currentLang] || menu.tab
          const html = menuName.replace(keyword, `<span style="color:red;">${keyword}</span>`)
          return { ...menu, html }
        })

      return menusList
    },
    likelySearchList () {
      const { keyword } = this.$data
      const { menus, currentLang } = this.$props
      const target = keyword.toLowerCase().trim()
      if (!target) {
        return []
      }
      const list = filterPane(menus, { lastMenu: 2 })
      const searchList = list.filter(menu => {
        if (menu.relationMenuList) {
          return menu.relationMenuList.find(item => item.menuName.toLowerCase().includes(target))
        }
        return false
      }).map(menu => {
        const menuName = menu.menuName[currentLang] || menu.tab
        const html = menuName.replace(keyword, `<span style="color:red;">${keyword}</span>`)

        return {
          ...menu,
          html
        }
      })
      return searchList
    },
    menusActiveID () {
      const { menus, activeKey } = this.$props
      let menusActiveID = ''

      for (const item of menus) {
        const isExit = findPane(item.childMenus, { key: activeKey })

        if (isExit) {
          menusActiveID = item.key
        }
      }

      return menusActiveID
    },
    ...mapGetters([
      'serviceId',
      'systemCode',
      'paidPageFlag'
    ])
  },
  watch: {
    keyword (val, oldVal) {
      if (oldVal && !val) {
        if (this.backspaceFlag && oldVal.length === 1) return
        if (oldVal.length === 1 && !this.keywordSelectAllFlag) return
        this.buriedShence({
          sea_ty: 'zs',
          sea_w: 'is_null',
          tru_w: oldVal
        })
      }
    }
  },
  methods: {
    i18nRender,
    show () {
      this.visible = true
    },
    hide () {
      setTimeout(() => {
        if (!this.buriedShenceFlag && this.keyword) {
          this.buriedShence({
            sea_ty: 'zs',
            sea_w: 'is_null',
            tru_w: this.keyword
          })
        }
        this.buriedShenceFlag = false
        this.visible = false
      }, 200)
    },

    searchKepDown (e) {
      if ((e.key === 'Backspace' || e.keyCode === 8) && !this.keywordSelectAllFlag) {
        this.backspaceFlag = true
        setTimeout(() => {
          this.backspaceFlag = false
        }, 350)
      } else if (e.key !== 'Backspace' && e.keyCode !== 8) {
        this.keywordSelectAllFlag = false
      }
    },

    // 神策埋点
    buriedShence (options = {}) {
      const {
        panes,
        iframes,
        activeKey
      } = this.$store.state.entry
      const activePane = [
        ...panes,
        ...iframes
      ].find(item => item.key === activeKey)

      if (!activePane) return
      this.buriedShenceFlag = true
      this.$Shence.track({
        p_na: activeKey === 'home' ? '首页' : activePane?.menuName?.zh_CN,
        ...options
      }, 'sea_bt')
    },

    back () {
      window.location.href = ((process.env.SSO_ENV || '') + '/#/user/home').replace(/^\/?/, '/')
      return false
    },
    viewAll () {
      this.buriedShence({
        sea_ty: 'list',
        tru_w: this.keyword || 'is_null',
        sea_w: '查看全部功能'
      })
      this.$emit('viewall')
    },
    handleMenusChange ({ key }) {
      switch (key) {
        case 'addCustomMenus':
          if (this.customMenus.length >= 30) {
            this.$notification.warning({
              message: i18nRender('notification-modal.title.prompt'),
              description: i18nRender('notification-modal.content.maxcustomscene')
            })
            return
          }
          this.$emit('menusadd', key)
          break
        default:
          this.$emit('menuschange', key)
      }
    },
    handleSearchClick (key, record = {}, menuName = '') {
      const { params: { serviceId, systemCode } } = this.$route
      const history = record.statisticsType === 3
      const type = history
        ? this.keyword ? 'zjdk' : 'ls'
        : this.keyword ? 'zs' : 'list'
      this.buriedShence({
        sea_ty: type,
        tru_w: this.keyword || 'is_null',
        sea_w: menuName,
        sea_cou: (!history && this.keyword) ? this.searchList.length : 'is_null'
      })
      const findItem = this.defaultList.find(item => item.key === key)
      if (findItem) {
        const { key, getPath, ...restParams } = findItem
        this.$store.dispatch('entry/SetActiveAsync', {
        ...restParams,
        path: getPath(serviceId, systemCode)
      })
      return
      }
      this.$emit('menuchange', key, record)
    },
    handleMenuChange (key, record = {}) {
      this.$emit('menuchange', key, record)
    },
    handleCustom (info) {
      this.$emit('custommenu', info || this.menuInfo)
    },
    handleDeleteMenu (info) {
      if (this.menusActiveID === `c_${info.menuId}`) {
        return this.$message.warning(i18nRender('layouts.customscene.currentNoDel'))
      }
      this.$confirm({
        icon: 'info-circle',
        title: i18nRender('notification-modal.title.prompt'),
        content: i18nRender('notification-modal.content.delete.customscene'),
        okText: i18nRender('form-modal.delete'),
        cancelText: i18nRender('form-modal.cancel'),
        onOk: () => {
          return this.$store.dispatch('entry/RemoveCustomMenu', info.menuId).then(data => {
            this.$message.success(data.message)
          })
        }
      })
    },
    switchPaidPageFlag () {
      const { serviceId, systemCode, paidPageFlag } = this
      const showUpdateFlag = paidPageFlag === 1 ? 2 : 1
      updateSystemUpdateFlag({
        serviceId,
        systemCode,
        showUpdateFlag
      }).then(() => {
        this.$store.commit('entry/SET_PAID_PAGE_FLAG', showUpdateFlag)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.entry-layout-header {
  padding: 0 10px;
  display: flex;
  height: 42px;
  line-height: 42px;
  background: #1E1E28 url('../../assets/bg-erp-head.png') no-repeat 100% 100%;
  overflow: hidden;
}

.entry-layout-header-logo {
  margin-left: -9px;
  width: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.entry-layout-header-nav {
  display: inline-flex;
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 42px;
  height: 42px;

  &__main {
    display: inline-flex;
    white-space: nowrap;
    overflow: hidden;
  }

  &__item {
    padding: 0 10px;
    color: #fff;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  }

  &__extra {
    flex: 1 0 auto;
  }

  &__btn {
    padding: 0 7px;
    display: inline-block;
    height: 42px;
    line-height: 42px;
    color: #ffffff;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }

    .anticon {
      vertical-align: baseline;
    }
  }
}

.entry-dropdown {
  color: #ffffff;

  &__name {
    padding: 0 14px;
    display: block;
    height: 42px;
    line-height: 42px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }

  &__name.@{ant-prefix}-dropdown-open {
    background: rgba(255, 255, 255, .25);
  }
}

.entry-dropdown-menu {
  width: 246px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333;

  .@{ant-prefix}-avatar {
    display: block;
    width: 14px;
    height: 14px;
    background-color: transparent;
    color: inherit;
    font-size: inherit;
    line-height: 14px;
  }

  &__hd {
    margin-right: 8px;
    position: relative;
    font-size: 13px;
    text-align:left;
  }
  &__bd {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .@{ant-prefix}-dropdown-menu-item-selected & {
      font-weight: 750;
    }
  }
  &__ft {
    margin-left: 8px;
    & > span {
      margin-left: 10px;
      color: rgb(86, 129, 244);
      display: inline-block;
      vertical-align: top;
      .anticon {
        font-size: 13px;
      }
      &:last-child {
        width: 50px;
        text-align: center;
      }
    }
  }
  &__btn {
    color: #333 !important;
    font-size: 12px !important;
    line-height: 18px !important;
    height: auto !important;
  }
}

// 菜单样式
.entry-layout-menus {
  flex: 1;
  min-width: 0;
  overflow: hidden;

  /deep/ .@{ant-prefix}-tabs {
    color: #ffffff;
  }

  /deep/ .@{ant-prefix}-tabs-tab-prev,
  /deep/ .@{ant-prefix}-tabs-tab-next {
    &,
    &:hover {
      color: #fff;
    }
  }

  /deep/ .@{ant-prefix}-tabs-nav .@{ant-prefix}-tabs-tab {
    margin-right: 0;
    padding: 0;
  }

  /deep/ .@{ant-prefix}-tabs-nav .@{ant-prefix}-tabs-tab-active {
    background: #077bfc;
    color: #ffffff;
  }

  /deep/ .@{ant-prefix}-tabs-bar {
    margin: 0;
    border: 0;
  }
}
.entry-layout-header-menus__item {
  display: inline-block;
  padding: 0 8px;
  cursor: pointer;
}
.entry-layout-header-menus__item__label {
  display: inline-block;
  padding: 0 11px;
  font-size: 12px;
  line-height: 45px;
  &--hover {
    background: #60ABFF;
    color: #fff;
  }
}
.entry-layout-header-menus__item__children {
  padding: 12px 0;
  background-color: #fff;
  max-width: 1124px;
  min-width: 200px;
  max-height: 90vh;
  display: flex;
  flex-wrap: wrap;
  box-shadow: 0px 2px 8px 2px rgba(168, 182, 196, 0.5);
  overflow: auto;

  &::-webkit-scrollbar {
    cursor: pointer;
    width: 6px;
    height: 0px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,.3);
    background-color: rgba(0,0,0,.3);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
  &__tools {
    position: absolute;
    z-index: 5;
    right: 5px;
    top: 0px;
  }
}

// 搜索框
.entry-layout-search-wrapper {
  padding: 0 11px;
  width: 182px;
  display: flex;
  align-items: center;
}
/deep/ .entry-layout-search-input {
  background-color: #464C59;
  border-radius: 2px;

  &.@{ant-prefix}-input-affix-wrapper .@{ant-prefix}-input-prefix {
    left: 6px;
    color:#fff;
  }

  &.@{ant-prefix}-input-affix-wrapper .@{ant-prefix}-input:not(:first-child) {
    padding-left: 23px;
    padding-right: 23px;
  }

  &.@{ant-prefix}-input-affix-wrapper .@{ant-prefix}-input-suffix {
    right: 6px;
    background-color: transparent;
    color: #fff;
  }

  .@{ant-prefix}-input {
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 12px;
  }
}
.entry-layout-history {
  margin: -12px -16px;
  display: flex;
  flex-direction: column;
  width: 432px;
  max-height: 285px;
  overflow: hidden;
}
.entry-layout-history__header {
  padding: 16px 16px 4px;
  display: flex;
  flex-direction: column;
}
.entry-layout-history__body {
  padding: 4px 16px;
  flex: 1;
  min-height: 0;
  overflow: hidden auto;
}
.entry-layout-history__title {
  font-weight: normal;
  font-size: 14px;
}
.entry-layout-history__list {
  margin-top: 10px;
  margin-left: -16px;
  overflow: hidden;
}
.entry-layout-history__item {
  margin-left: 16px;
  margin-bottom: 12px;
  float: left;
  padding: 0 9px;
  background: #E9EDFA;
  border-radius: 24px;
  color: #252B3A;
  font-size: 12px;
  line-height: 2;
  cursor: pointer;
}
.entry-layout-history__link {
  margin-left: -16px;
  margin-right: -16px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: #EDF1FB;
  }
}
.entry-layout-history__empty {
  color: #999;
  text-align: center;
  line-height: 40px;
}
.entry-layout-history__link__main {
  flex: 1;
  line-height: 30px;
}
.entry-layout-history__link__icon {
  font-size: 12px;
}
.entry-layout-history__foot {
  border-top: 1px solid #eee;
  color: #484848;
}
.entry-layout-history__foot__btn {
  text-align: center;
  line-height: 43px;
  cursor: pointer;
}
</style>
